import types from '@/actions/commonTypes';

export const _loading = () => {
  return {
    type: types.LOADING
  }
}

export const _loaded = () => {
  return {
    type: types.LOADED
  }
}


// WEBPACK FOOTER //
// ./src/actions/commonAction.js